module.exports = __webpack_public_path__ + "img/legalServices-13.29ecb998.png";